import { get, isError } from 'lodash';
function isHttpError(possibleError) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (isError(possibleError)) {
    return !status || get(possibleError, 'response.status') === status;
  }
  return false;
}
export default isHttpError;
//# sourceMappingURL=isHttpError.js.map